module.exports = __webpack_public_path__ + "img/Constant Learner.0bdce718.svg";